import { CURRENCY_NOT_SET_LABEL } from '@/lib/format-money';

/**
 * Inline marker shown right after an amount whose currency is not set, so the
 * bare number is not read as a price in some assumed currency.
 */
export function NoCurrencyMarker(): JSX.Element {
  return (
    <span className="ml-1 text-xs font-normal text-amber-700" data-testid="price-no-currency-marker">
      {CURRENCY_NOT_SET_LABEL}
    </span>
  );
}
